/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ code: NonNullable<unknown>, value: NonNullable<unknown> }} Billing_Auto_PromoInputs */

const en_billing_auto_promo = /** @type {(inputs: Billing_Auto_PromoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Auto promo ${i?.code}: ${i?.value} off, applied at checkout`)
};

const id_billing_auto_promo = /** @type {(inputs: Billing_Auto_PromoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Promo otomatis ${i?.code}: potongan ${i?.value}, dipakai saat checkout`)
};

/**
* | output |
* | --- |
* | "Auto promo {code}: {value} off, applied at checkout" |
*
* @param {Billing_Auto_PromoInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const billing_auto_promo = /** @type {((inputs: Billing_Auto_PromoInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Auto_PromoInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_billing_auto_promo(inputs)
	return en_billing_auto_promo(inputs)
});